import { ItemStatusDto, ItemWithStatus } from '../constants';

export const getItemWithStatus = (
  instanceId: string,
  userItemStatuses?: ItemStatusDto
): ItemWithStatus | undefined => {
  const findItem = ({ item }) => instanceId === item.instanceId;

  const itemLoan = userItemStatuses?.loans?.find(findItem);

  if (!itemLoan) {
    return userItemStatuses?.holds?.find(findItem);
  }

  const itemChargeData = userItemStatuses?.charges?.find(
    ({ item }) => itemLoan.item.itemId === item?.itemId
  );

  return {
    ...itemLoan,
    ...itemChargeData?.chargeAmount,
  };
};
